import React from "react";

import { CloseIcon } from "src/assets/icons/close_icon";
import { SwitchCheckIcon } from "src/assets/icons/switch_check_icon";

import "./toggle.scss";

/*
 * Types
 */

export interface ToggleProps extends React.InputHTMLAttributes<HTMLInputElement> {
    readonly label?: string;
}

/*
 * Main
 */

export const Toggle = (props: ToggleProps): React.ReactElement => {
    const { label, name, ...rest } = props;

    return (
        <div className="toggle-component-wrap">
            {label && (
                <label className="toggle__ally-label" htmlFor={name}>
                    {label}
                </label>
            )}
            <input className="react-switch-checkbox" id={name} name={name} type="checkbox" {...rest} />
            <label className="react-switch-label" htmlFor={name}>
                <span className="react-switch-button">
                    <span className="switch-close-svg">
                        <CloseIcon />
                    </span>
                    <span className="switch-check-svg">
                        <SwitchCheckIcon />
                    </span>
                </span>
            </label>
        </div>
    );
};
